/**
 * APP IDENTITY — the one place to change the product name and bundle id.
 *
 * `bundleId` is the reverse-domain identifier used by the App Store and
 * Play Store. It does NOT have to be a real domain, but it can NEVER be
 * changed after the first store release. Everything else here is free to
 * change at any time.
 *
 * 2026-10-14: name RouteBack, seller Hidden Arrow Inc. The bundle id must be
 * checked for availability when the App ID is registered in Hidden Arrow's
 * Apple developer account, before the first store build.
 */
export const APP = {
  name: 'RouteBack',
  shortName: 'RouteBack',
  description: 'The back office for your routes — fleet maintenance, driver documents and scheduling for ISPs',
  bundleId: 'com.hiddenarrowinc.routeback',
  version: '0.1.0-dev',
} as const;
